import { usePageTitle } from '@global-dax-ad-platform/dax-hooks';
import { Container } from '@global-engineering-shared/gweb-material-ui';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';

import LoadableComponent from 'components/LoadableComponent';
import { useRefresh } from 'context/RefreshProvider/RefreshProvider';
import EntityActionBar from 'features/Entity/components/EntityActionBar';
import EntityDetailsBody from 'features/EntityDetails/components/EntityDetails/EntityDetailsBody';
import EntityDetailsHeader from 'features/EntityDetails/components/EntityDetails/EntityDetailsHeader';
import { initialFrameDetailsState } from 'features/Frames/pages/FrameDetailsPage/utils/initialFrameDetailsState';
import useFetchData from 'hooks/useFetchData';
import { ILiveFrame } from 'types/detailsEntityType';
import { EntityType } from 'types/entityType';
import { DEFAULT_TITLE, FRAMES_API_URL, ENTITY_PAGE_URL } from 'utils/defaults';

type FrameParams = {
  frameId: string;
};

const FrameDetailsPage = () => {
  const { refreshToggle } = useRefresh();
  const { frameId } = useParams<FrameParams>();
  const { getData, isDataLoading } = useFetchData();
  const [frame, setFrame] = useState(initialFrameDetailsState);

  useEffect(() => {
    if (frameId) {
      const url = `${FRAMES_API_URL}/${frameId}`;

      const retrieveFrame = async () => {
        await getData<ILiveFrame>(url, (response) => {
          if (response.entityType === EntityType.FRAME) {
            setFrame(response);
          }
        });
      };

      retrieveFrame();
    }
  }, [frameId, refreshToggle]);

  usePageTitle(DEFAULT_TITLE, `Frame ${frameId}`);

  return (
    <main>
      <LoadableComponent loading={isDataLoading}>
        <Container maxWidth="lg">
          <EntityDetailsHeader
            entity={frame}
            linkLabel="Frames"
            backLink={ENTITY_PAGE_URL}
            entityLabel="Frame"
          />
          <EntityDetailsBody entity={frame} otherComponents={<EntityActionBar entity={frame} />} />
        </Container>
      </LoadableComponent>
    </main>
  );
};

export default FrameDetailsPage;
